import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class SharedService {
    private autoSignInSubject = new BehaviorSubject<boolean>(false);
    autoSignIn$ = this.autoSignInSubject.asObservable();
    setAutoSignInValue(autoSignIn: boolean) {
        this.autoSignInSubject.next(autoSignIn);
    }
}